<template>
  <div class="fund_manage" style="overflow: scroll;">
    <!--    <a-tabs defaultActiveKey="1" @change="handCut">-->
    <!--      <a-tabs :defaultActiveKey="activeKey" @change="handCut">-->
    <div id="app" v-cloak>
      <div class="tipsBox">
        <div class="tipsTitle">操作手册</div>
        <div class="tipsText">
          <div>
            ①
            根据使用习惯,下载相应语言的CSV文件,例如中国内地用户下载简体中文语言的文件，港台用户下载繁体语言的文件;
          </div>
          <div>② 填写csv文件,可以使用excel或文本编辑器打开csv文件;</div>
          <div>
            商品封面图和商品展示图请填写带路径的图片文件名，其展示图路径是相对于
            [根目录]/images/
            的路径，例如图片路径为[根目录]/images/200610/abc.jpg,只要填写
            200610/abc.jpg 即可;
          </div>
          <div>③ 需要先选择商品分类和品牌分类，再进行模板下载;</div>
          <div>
            ④
            CSV文件中一次上传商品数量最好不要超过40,CSV文件大小最好不要超过500K
          </div>
          <div>
            ⑤
            上传相同文件，则覆盖前一个文件的内容；上传不同文件，效果同上，上传的文件名显示在按钮下方。
          </div>
        </div>
      </div>

      <el-main style="overflow-y: auto;">
        <div>
          <el-form
            ref="ruleForm"
            :rules="rules"
            class="form-search"
            id="addform"
            :model="ruleForm"
            label-width="120px"
            action="index.php?module=product&action=import"
            method="post"
            enctype="multipart/form-data"
          >
            <el-card class="box-card">
              <el-row :gutter="4">
                <el-col :span="24">
                  <!-- <el-form-item label="商品分类" prop="product_class">
												<el-cascader
													style="width: 100%;"
													v-model="ruleForm.product_class"
													placeholder="请选择商品分类"
													:props="props"
													@change="cidChange"
													clearable></el-cascader>											
											</el-form-item>
											<el-form-item label="商品品牌" prop="brand_class">
												<el-select placeholder="请选择商品品牌" v-model="ruleForm.brand_class" @visible-change="showtoast($event)" style="width: 100%;" clearable>
													<el-option v-for="(item,index) of brand_list" :key="item.brand_id" :label="item.brand_name" :value="item.brand_id"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item label="运费" prop="freight_id" >
												<el-select placeholder="请选择运费" v-model="ruleForm.freight_id" style="width: 100%;" clearable>
													<el-option v-for="(item,index) of freight_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item> -->
                  <el-form-item label="下载模板">
                    <a href="example.xlsx" target="_blank"
                      >点击此处下载template.xls文件</a
                    >
                  </el-form-item>
                  <el-form-item label="批量导入商品" prop="file">
                    <input type="hidden" name="m" value="goodsImport" />
                    <input type="hidden" name="action" value="product" />
                    <input type="hidden" name="module" value="pc_api" />
                    <input
                      type="hidden"
                      name="product_class"
                      :value="
                        ruleForm.product_class[
                          ruleForm.product_class.length - 1
                        ]
                      "
                    />
                    <input
                      type="hidden"
                      name="brand_class"
                      :value="ruleForm.brand_class"
                    />
                    <input
                      type="hidden"
                      name="freight_id"
                      :value="ruleForm.freight_id"
                    />
                    <div class="up-text">上传文件</div>
                    <input
                      type="file"
                      name="file"
                      id="text1"
                      @change="upFile"
                    />
                    <p class="upfile" id="upfile"></p>
                    <!-- <input type="button" value="保存" id="subTn" @click="submitForm"> -->
                    <!-- <input type="submit" value="保存" id="subTnt" @click="submitForm2" style="display: none;">
												 <a href="example.csv" target="_blank" style="position: absolute;right: 0;top: 0;">下载批量导入模板</a> -->
                  </el-form-item>
                </el-col>
              </el-row>
            </el-card>
          </el-form>
        </div>
      </el-main>

      <div class="footer-button" style="z-index: 9;">
        <el-button plain class="footer-cancel" @click="Back">取消</el-button>
        <el-button type="primary" class="footer-save" @click="submitForm2"
          >确定导入</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loadFlag: false,
      ruleForm: {
        m: 'goodsImport',
        action: 'Import',
        module: 'product',
        product_class: '', // 产品标题
        brand_class: '', // 小标题
        freight_id: '', // 运费ID
        file: ''
      },
      brand_list: [],
      freight_list: [],
      props: {
        value: 'cid',
        label: 'pname',
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, value } = node

          //let url = 'index.php?module=product&action=Ajax&cid='+value
          let data = { class_str: value, brand_str: '' }
          this.$request
            .get('?module=pc_api&action=product&app=get_class', {
              params: data
            })
            .then(res => {
              this.ruleForm.brand_id = ''
              if (this.ruleForm.product_class) {
                this.brand_list = res.list.brand_list.filter(item => {
                  return item.brand_id != 0
                })
              } else {
                this.brand_list = []
              }

              if (res.list.class_list.length > 0) {
                const nodes = Array.from(res.list.class_list[0]).map(item => ({
                  ...item,
                  leaf: level >= 2
                }))
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes)
              } else {
                resolve([])
              }
            })
        }
      },
      fileList: [],
      rules: {
        product_class: [
          { required: true, message: '请选择商品分类', trigger: 'change' }
        ],
        brand_class: [
          { required: true, message: '请选择商品品牌', trigger: 'change' }
        ],
        freight_id: [
          { required: true, message: '请选择运费', trigger: 'change' }
        ],
        file: [{ required: true, message: '请选择上传文件', trigger: 'change' }]
      }
    }
  },
  computed: {},
  watch: {},
  mounted () {
    this.get_freight()
  },
  methods: {
    upFile (e) {
      console.log(e)
      $('#upfile').text($('#text1').val())
      this.ruleForm.file = e.target.files
      console.log(e.target.files)
      console.log(this.ruleForm.file)
    },
    // 商品分类
    cidChange (arr) {
      console.log(this.ruleForm.product_class, 222)

      this.ruleForm.brand_class = ''
      if (arr.length == 0) {
        this.brand_list = []
        return
      }
      if (arr.length < 3) {
        let val = arr.join(',')
        $('.el-cascader-panel')
          .find(`[value="${val}"]`)
          .parents('li')
          .click()
      }
      let end = arr[arr.length - 1]
      this.getBrandByClass(end)
    },
    getBrandByClass (class_id) {
      //let url = 'index.php?module=product&action=Ajax&cid='+class_id
      let data = { class_str: class_id, brand_str: '' }
      this.$request
        .get('?module=pc_api&action=product&app=get_class', { params: data })
        .then(res => {
          let { code, message, list } = res

          if (code === 200) {
            if (this.editLoadFlag) {
              this.ruleForm.brand_class = ''
            }
            if (this.ruleForm.product_class) {
              this.brand_list = res.list.brand_list.filter(item => {
                return item.brand_id != 0
              })
            } else {
              this.brand_list = []
            }
          }
        })
    },
    //商品品牌input提示
    showtoast (e) {
      if (this.ruleForm.product_class == '' && e == true) {
        this.$message.warning('请先选择商品分类')
      }
    },
    submitUpload () {
      this.$refs.upload.submit()
    },
    handleRemove (file, fileList) {
      console.log(file, fileList)
      this.ruleForm.file = ''
    },
    handlePreview (file) {
      console.log(file)
    },
    fileBefore (file) {
      this.ruleForm.file = file
      console.log(this.ruleForm.file, 222)
    },
    // 上传模板保存
    submitForm2 () {
      this.$refs.ruleForm.validate(valid => {
        console.log(valid, 333)
        if (valid) {
          if ($('#text1').val() == '') {
            this.$message.warning('请选择上传文件')
            return false
          }
          // if($("#text1").val().indexOf(".csv")=="-1"){
          // 	this.$message.warning('上传文件格式不对')
          // 	return false;
          // }

          console.log('=====submitForm2')

          let me = this
          let data = new FormData()
          data.append('file', this.ruleForm.file[0])
          data.append(
            'product_class',
            this.ruleForm.product_class[this.ruleForm.product_class.length - 1]
          )
          data.append('brand_class', this.ruleForm.brand_class)
          data.append('freight_id', this.ruleForm.freight_id)

          this.$request
            .post('?module=pc_api&action=product&app=goodsImport', data)
            .then(res => {
              if (res.code == 200) {
                this.$message.success(res.message)
                this.$router.go(-1)
              } else {
                this.$message.warning(res.message)
              }
            })
        } else {
          return false
        }
      })
    },
    // 确定导入
    submitForm () {},
    // 取消
    Back () {
      this.$router.go(-1)
    },
    // 获取运费
    get_freight () {
      this.$request
        .get('?module=pc_api&action=product&app=add_product_page')
        .then(res => {
          if (res.code == 200) {
            this.freight_list = res.freight.filter(item => {
              return item.id != 0
            })
          }

          // let url = `index.php?module=product&action=Import&m=get_freight`;
          // this.$request.get(url,{}).then(res=>{
          // 	let { code, data, message } = res;
          // 	console.log(data)
          // 	this.freight_list = data.freight_list.filter(item=>{
          // 		return item.id != 0
          // 	})
        })
    }
  }
}
</script>
<style lang="less">
.el-form-item {
  margin-bottom: 11px !important;
}
.fund_manage {
  overflow: scroll;
  height: 100%;
}
.el-card.is-always-shadow,
.el-card.is-hover-shadow:focus,
.el-card.is-hover-shadow:hover {
  box-shadow: none;
}
.el-checkbox-group,
.el-radio-group {
  display: flex;
  align-items: center;
  height: 40px;
}

#editor {
  line-height: 0;
}

.el-table .el-input {
  text-align: center;
}

.v-modal {
  z-index: 0 !important;
  background-color: transparent !important;
}

.el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}

.el-table .l-upload {
  display: flex;
  justify-content: center;
}

.el-table__fixed-right::before,
.el-table__fixed::before {
  z-index: 2;
}

.el-table .el-input__inner {
  text-align: center;
}

.el-checkbox,
.el-radio {
  display: flex;
  align-items: center;
}

.el-table th {
  background-color: #f4f7f9;
}

.edui-default .edui-editor {
  z-index: 9 !important;
}

.el-table-filter .el-checkbox-group,
.el-table-filter .el-radio-group {
  height: auto;
  min-height: 40px;
  width: 160px;
  flex-wrap: wrap;
  align-items: flex-start;
  flex-direction: column;
}
.el-table-filter .el-checkbox__label {
  max-width: 120px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.el-table-filter__checkbox-group label.el-checkbox {
  display: flex;
}

// .el-table-filter__checkbox-group .el-checkbox:last-child {
//   margin-bottom: ;
// }

.el-table-filter__bottom {
  display: flex;
  justify-content: flex-end;
}

// .el-card__body {
// }

.el-input__inner[type='number'] {
  padding-right: 0;
}

.el-card__header[class] {
  font-size: 16px;
  color: #414658;
}

.el-table thead tr {
  height: 50px;
  line-height: 50px;
}

.el-table th {
  padding: 0;
  height: 48px;
  line-height: 48px;
}

.el-checkbox__input {
  display: flex;
  align-items: center;
}

.el-checkbox__label {
  line-height: 14px;
}

.el-checkbox,
.el-radio {
  color: #414658;
}

.el-checkbox__input.is-checked + .el-checkbox__label,
.el-radio__input.is-checked + .el-radio__label {
  color: #2890ff;
}

.el-radio__inner {
  border-color: #b2bcd1;
}

.el-radio__input.is-checked .el-radio__inner {
  background-color: #2890ff;
  border-color: #2890ff;
}

.el-checkbox,
.el-radio {
  margin-right: 20px !important;
}

.dialog-container
  .file-list-tab-pane
  .file-list
  .file-list-left
  .infinite-list
  li
  .infinite-list-checked[data-v-02a3d240] {
  right: -17px !important;
}

.tipsBox {
  background: #e9f4ff;
  border: 1px dashed #2890ff;
  margin: 20px 20px 0;
  padding: 17px;
}
.tipsTitle {
  line-height: 20px;
  // background: url(../../../../images/icon1/textTips.png) no-repeat left center;
  font-size: 6px;
  font-weight: bold;
  color: #2890ff;
}
.tipsText {
  color: #6a7076;
  line-height: 20px;
  font-size: 5px;
}
.el-form-item__error {
  width: 240px;
  height: 10px;
}
.up-text {
  height: 36px;
  line-height: 36px;
  padding: 0 15px 0 38px;
  border-radius: 2px;
  background: url(../../assets/dr.png) #38b4ed no-repeat left 16px center;
  color: #ffffff;
  display: inline-block;
}
#text1 {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
}
.el-card__body {
  width: 680px;
  height: 100%;
  margin: 0 auto;
  overflow-y: auto;
  padding-right: 10px;
}
.footer-button {
  right: 30px;
  bottom: 30px;
  position: absolute;
  margin-right: 20px;
  margin-bottom: 15px;
  justify-content: end;
  display: flex;
  z-index: 9;
}
</style>
